import React from "react";
import { Container, Row, Col, Image, Figure } from "react-bootstrap";
import { connect } from "react-redux";
import { introductionTable, aboutDetailsTable } from "../firebase/content";
import { updateContent } from "../actions/cartAction";
import Editable from "./Editable";
import EditableImage from "./EditableImage";

class About extends React.Component {
  imageUrl(image) {
    return (this.props.images.find((x) => x.name === image) || {}).url;
  }

  onInput(object, key) {
    return (text) => {
      object[key] = text;
    };
  }

  render() {
    let { editable } = this.props;
    let {
      [introductionTable]: introduction,
      [aboutDetailsTable]: aboutDetails,
    } = this.props.content;
    introduction = introduction || {};
    return (
      <div className="about-section" id="about">
        <div className="about-section-welcome">
          <h1>VỀ CHÚNG TÔI</h1>
          <section className="welcome-content">
            {(introduction.text || []).map((text) => {
              return (
                <Editable
                  editable={editable}
                  key={text.id}
                  object={text}
                  field="line"
                >
                  <p>{text.line}</p>
                </Editable>
              );
            })}
            <Editable
              editable={editable}
              object={introduction}
              field="signature"
            >
              <p className="signature">{introduction.signature}</p>
            </Editable>
          </section>
        </div>
        <Container className="about-content">
          <Row>
            {(aboutDetails || []).map((about) => {
              return (
                <Col className="image-hover" key={about.id}>
                  <Figure>
                    <EditableImage editable={editable} object={about}>
                      {({ url, select }) => {
                        return <Image src={url} onClick={select} />;
                      }}
                    </EditableImage>
                  </Figure>
                  <Editable
                    editable={editable}
                    onInput={this.onInput(about, "text")}
                  >
                    <p>{about.text}</p>
                  </Editable>
                </Col>
              );
            })}
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    content: state.content,
    images: state.images,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateContent() {
      dispatch(updateContent(...arguments));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(About);
